import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

// Components
import TableRow from './TableRow';
import TableHead from './TableHead';

// Services
import { updateSingleAppointmentInList } from '../../reducer/actions';
import {
  changeTab,
  addActiveAppointment
} from 'src/views/practitioner/Appointment/reducers/actions';
import { triggerWorkflow } from 'src/views/practitioner/Appointment/reducers/workflow';
import { setBackUrl } from '../../../reducer/commonActions';

// Styles & Images
import { Table, EmptyBlock } from './tableStyles';
import NoAppointmentsSvg from 'assets/images/no-appointmets.svg';

class TableComponent extends Component {
  constructor() {
    super();
    this.state = {
      filterAppointmentsList: []
    };
    this.filteringByCampus = this.filteringByCampus.bind(this);
    this.selectAppointment = this.selectAppointment.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { commonFilters, appointmentsList } = this.props;
    // Filtering by campuses
    if (
      (prevProps &&
        prevProps.commonFilters &&
        prevProps.commonFilters.campusId !== commonFilters.campusId) ||
      JSON.stringify(prevProps.appointmentsList) !== JSON.stringify(appointmentsList)
    ) {
      this.filteringByCampus();
    }
  }

  filteringByCampus() {
    const { appointmentsList } = this.props;
    const { campusId } = this.props.commonFilters;

    if (Array.isArray(appointmentsList)) {
      if (campusId) {
        const filterArr = appointmentsList.filter(
          appointment => String(appointment.campus.id) === String(campusId)
        );
        this.setState({ filterAppointmentsList: filterArr });
      } else if (!campusId) {
        this.setState({ filterAppointmentsList: appointmentsList });
      }
    }
  }

  selectAppointment(item) {
    this.props.addActiveAppointment(item);
    this.props.changeTab();
  }

  render() {
    const {
      changeTab,
      i18n,
      openVerifyModal,
      push,
      role,
      selectedAppointmentStatus,
      setBackUrl,
      triggerWorkflow,
      updateSingleAppointmentInList
    } = this.props;

    const { filterAppointmentsList } = this.state;

    return Array.isArray(filterAppointmentsList) && filterAppointmentsList.length ? (
      <Table>
        <TableHead i18n={i18n} />
        <tbody>
          {filterAppointmentsList.map(appointment => {
            return (
              <TableRow
                appointment={appointment}
                key={appointment.id}
                addActiveAppointment={this.selectAppointment}
                setBackUrl={setBackUrl}
                push={push}
                openVerifyModal={openVerifyModal}
                triggerWorkflow={triggerWorkflow}
                changeTab={changeTab}
                role={role}
                selectedAppointmentStatus={selectedAppointmentStatus}
                updateSingleAppointmentInList={updateSingleAppointmentInList}
              />
            );
          })}
        </tbody>
      </Table>
    ) : (
      <EmptyBlock>
        <div>
          <img src={NoAppointmentsSvg} alt="No appointments"/>
          <p>{i18n.t('placeholder_no_appointments')}</p>
        </div>
      </EmptyBlock>
    );
  }
}

const mapStateToProps = state => ({  
  commonFilters: state.practitioner.common.commonFilters,
  role: state.auth.role,
  selectedAppointmentStatus: state.practitioner.appointments.filters.selectedAppointmentStatus
});

export default translate()(
  connect(
    mapStateToProps,
    {
      addActiveAppointment,
      updateSingleAppointmentInList,
      changeTab,
      triggerWorkflow,
      push,
      setBackUrl
    }
  )(TableComponent)
);
